import React from 'react';
import './Skills.css';

// Skill proficiency levels
const skillProficiency = {
    TypeScript: 80,
    Java: 80,
    JavaScript: 90,
    'Node.js': 80,
    'C#': 80,
    '.NET': 80,
    React: 90,
    Angular: 50,
    Python: 40,
    Git: 90,
    Docker: 70,
    AzureDevOps: 50,
    CircleCI: 70,
    PostgreSQL: 90,
    MongoDB: 90,
    Tableau: 70,
    Linux: 70,
    RestfulAPI: 90,
    HTML5: 90,
    CSS: 90,
    jQuery: 60,
    JSON: 80,
    JSP: 70,
    Bootstrap: 60,
    AdobeAnalytics: 70,
    S3: 90,
    Scaling: 70,
    DynamoDB: 80,
    StepFunction: 70,
    API_Gateway: 80,
    EC2: 80,
    XRAY_Tracing: 90,
    QuickSight: 80,
    EventBridge: 80,
};

// Sort skills by proficiency in descending order
const sortedSkills = Object.entries(skillProficiency).sort((a, b) => b[1] - a[1]);

function Skills() {
    return (
        <div className="skills">
            <h2 data-aos="zoom-in">Skills</h2>
            <div className="skills-container">
                {sortedSkills.map(([skill, proficiency]) => (
                    <div key={skill} className="skill-item" data-aos="fade-up">
                        <span className="skill-name">{skill}</span>
                        <div className="progress-bar-container">
                            <div
                                className="progress-bar"
                                style={{ width: `${proficiency}%` }}
                            >
                                {proficiency}%
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Skills;